<template>
  <div class="footer text-left pt-6">
    <v-row>
      <v-col :cols="12" :sm="6">
        <FooterLocation />
        <FooterHourTable class="mt-6" />
      </v-col>
      <v-col :cols="12" :sm="6">
        <v-lazy>
          <FooterMap
              type="maplibre"
              :title="$t('footer.location')"
              height="330px"
          />
        </v-lazy>
      </v-col>
      <!--
      <v-col :cols="4">
        <FooterHourTable />
      </v-col>
      -->
    </v-row>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.footer {
  text-align: center;

  p {
    font-size: 25px;
  }
}
</style>